import React from "react";

type MainSubmitProps = {
  children: JSX.Element;
  onSubmit: () => any;
};

export default function MainSubmit({ children, onSubmit }: MainSubmitProps) {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit();
  };
  return <form onSubmit={handleSubmit}>{children}</form>;
}
